angular.module('impactx.rfx').controller('RFXAddSupplierListCtrl', RFXAddSupplierListCtrl);

RFXAddSupplierListCtrl.$inject = ['$scope', 'dataGen', 'TranslationService','ToastService', '$mdDialog', '$redirect', '$filter', 'config', 'themeFactory'];

function RFXAddSupplierListCtrl($scope, dataGen, TranslationService, ToastService, $mdDialog, $redirect, $filter, config, themeFactory) {

    var self = this;
    self.config = config;

    $scope.theme = themeFactory.getTheme();

    $scope.abortLabel = TranslationService.get("abort");
    $scope.acceptLabel = TranslationService.get("save");
    $scope.forwardLabel = TranslationService.get("forward");

    $scope.wizardIndex = 0;
    $scope.isLoading = true;
    $scope.entriesToAdd = [];

    function getData() {
        dataGen.getData($scope, {rfqhId: self.config.rfqhId,
            afterSend: self.config.afterSend,
            tenderId: self.config.tenderId,
            lotId: self.config.lotId
        }, "/rfx/buyer/addSupplierList").then(function () {
            if (!impactX.isDefined($scope, 'data.message')) {
                $scope.wizardIndex = 1;
                self.refreshData();
            }
        });
    };

    self.refreshData = function() {
        $scope.isLoading = true;
        dataGen.getData({}, {rfqc: self.config.rfqcId,
                searchData: $scope.data.searchData,
                useBuyerContext: !!self.config.useBuyerContext,
                rfqhId: self.config.rfqhId
            }, "/rfx/buyer/addSupplierList/search").then(function (response) {
            if (impactX.isDefined(response, 'data')) {
                $scope.data.searchResults = filterResult(response.data.entries);
            }
            $scope.isLoading = false;
        });
    }

    function filterResult(response) {
        if (self.config.selected) {
            return $filter('filter')(response, function (value) {
                var notContains = true;
                for (var i = 0; i < self.config.selected.length; i++) {
                    notContains = self.config.selected[i].id !== value.id;
                    if (!notContains) {
                        break;
                    }
                }
                return notContains;
            })
        }
        else {
            return response;
        }
    }

    self.next = function () {
        $scope.wizardIndex = $scope.wizardIndex + 1;
        if($scope.wizardIndex == 1)
        {
            self.refreshData();
        }
    };

    self.apply = function () {
        if(self.config.afterSend)
        {
            $scope.data.relatedSuppliers.push(...$scope.entriesToAdd);
            dataGen.postAsForm({}, {formData: $scope.data}, '/rfx/buyer/saveNewSuppliers').then(function () {
                ToastService.openStandardToast(TranslationService.get('saveSuccess'));
                $redirect.redirectTo(null, '/rfxbuyerlist');
                $mdDialog.hide();
            });
        }
        else
        {
            $mdDialog.hide($scope.entriesToAdd);
        }
    };

    self.cancel = function () {
        $mdDialog.cancel();
    };

    self.clearInput = function(filter) {
        filter.value = null;
        self.refreshData();
    }

    self.isSelected = function (entry) {
        return entry && $scope.entriesToAdd.findIndex((item) => item.id === entry.id) >= 0;
    }

    self.toggleSelect = function (event, entry) {
        if (entry) {
            const index = $scope.entriesToAdd.findIndex(item => item.id === entry.id);
            if(index >= 0) {
                $scope.entriesToAdd.splice(index, 1)
            }
            else {
                $scope.entriesToAdd.push(entry);
            }
            event.stopPropagation();
        }
    };

    getData();
}